import { Button, FormControl, FormLabel, TextField } from "@mui/material";

export function Input(props) {
  return (
    <Button
      type="submit"
      fullWidth
      variant={props.variant}
      sx={{ mt: 3, mb: 2 }}>
      {props.value}
    </Button>
  );
}

export function TextFieldForm(props) {
  return (
    <FormControl margin={props.margin} required fullWidth>
      <FormLabel
        sx={{
          fontWeight: "bold",
          fontSize: "12px",
          fontFamily: "Poppins, light[300], sans-serif",
        }}>
        {props.label}
      </FormLabel>
      <TextField
        margin={props.margin}
        required
        fullWidth
        placeholder={props.placeholder}
        name={props.name}
        type={props.type}
        id={props.id}
        autoComplete={props.autoComplete}
      />
    </FormControl>
  );
}
